function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { INITMENU, CHANGESUBMENU, CHANGEITEM, RESET, CHANGELOGIN, CHANGEACTIVITY, CHANGEBUSINESS } from '../mutation-types'; // import Bus from "@/assets/js/Bus"

import { getApi, postApi } from '@/api';
import router from '@/router';
import util from '@/libs/util';
import DYC_URL from '../../../../api/url';
import menuLibs from '@/libs/menu';
var authToken = util.cookies.get('auth-token'); // 根据cooike作为是否登录状态的唯一标识

!authToken && localStorage.removeItem('userData');
var userData = authToken ? JSON.parse(localStorage.getItem('userData')) : '';
var cartNum = localStorage.getItem('cartNum');
var collectNum = localStorage.getItem('collectNum');
var activeName = '';
var selectedActivity = sessionStorage.getItem('selectedActivity');
var selectedBusiness = sessionStorage.getItem('selectedBusiness');
var noReadCount = sessionStorage.getItem('noReadCount');
var traceId = sessionStorage.getItem('traceId') ? sessionStorage.getItem('traceId') : '';
var isOneThingYard = localStorage.getItem('isOneThingYard'); // 是否启用一物一码 false:未启用 true:启用

var state = {
  isCollapsed: false,
  activeNav: '',
  // 顶部导航menuCode
  extMenu: false,
  // 是否外部系统菜单，外部系统（true 或 1），非外部系统（false 或 0）
  activeName: '',
  // 三级菜单menuCode
  openName: '',
  // 二级菜单menuCode
  menu: [],
  // 全部菜单列表
  subMenu: [],
  // 左侧显示的二级、三级菜单列表
  step: [],
  temp: '',
  traceId: traceId,
  isLogin: userData ? userData.isLogin : false,
  // 是否登录
  userInfo: userData ? userData.userInfo : {},
  // 用户信息
  cartNum: cartNum || '',
  // 购物车数量
  collectNum: collectNum || '',
  selectedActivity: selectedActivity || '',
  selectedBusiness: selectedBusiness || '0',
  // 分页存储
  listPagePars: new Map(),
  // 未读消息
  noReadCount: noReadCount || 0,
  // 查询信息存储
  fullScaleDisplay: new Map(),
  // 机构管理增加树定位
  orgIdReqItem: '',
  relSkuType: '',
  // w维护关联商品tab
  hostCatalogName: localStorage.getItem('hostCatalogName') ? localStorage.getItem('hostCatalogName') : '[]',
  isOneThingYard: isOneThingYard || false,
  isMenuExpand: localStorage.getItem('isMenuExpand') === 'false' ? false : true,
  // 运营菜单是否展开 true展开 false 折叠
  isExistStatementOfAccount: false // 内部用户买家是否存在对账单未处理

}; // getters

var getters = {
  getRelSkuType: function getRelSkuType(state) {
    return state.relSkuType;
  },
  getMenu: function getMenu(state) {
    return state.menu;
  },
  getOrgId: function getOrgId(state) {
    return state.orgId;
  },
  getSubMenu: function getSubMenu(state) {
    return state.subMenu;
  },
  getOpenName: function getOpenName(state) {
    return state.openName;
  },
  getActiveName: function getActiveName(state) {
    return state.activeName;
  },
  getActiveNav: function getActiveNav(state) {
    return state.activeNav;
  },
  getExtMenu: function getExtMenu(state) {
    return state.extMenu;
  },
  getCrumbs: function getCrumbs(state) {
    if (state.menu.length && state.activeName) {
      state.step = [];
      var active = state.activeName;
      var l1 = level1(active);
      var l2 = level2(active);
      var l3 = level3(active);
      state.step = [l1, l2, l3];
      return state.step;
    } else {
      return state.step = [{
        menuName: '首页'
      }];
    }
  },
  geTraceId: function geTraceId(state) {
    return state.traceId;
  },
  getUserInfo: function getUserInfo(state) {
    return state.userInfo || {};
  },
  getIsLogin: function getIsLogin(state) {
    return state.isLogin;
  },
  getNum: function getNum(state) {
    return state.cartNum;
  },
  collectNum: function collectNum(state) {
    return state.collectNum;
  },
  getSelectedActivity: function getSelectedActivity(state) {
    return state.selectedActivity;
  },
  getSelectedBusiness: function getSelectedBusiness(state) {
    return state.selectedBusiness;
  },
  getNoReadCount: function getNoReadCount(state) {
    return state.noReadCount;
  },
  getOneThingYard: function getOneThingYard(state) {
    return state.isOneThingYard;
  },
  getMenuExpand: function getMenuExpand(state) {
    return state.isMenuExpand;
  }
}; // mutations

var mutations = {
  INITMENU: function INITMENU(state, payload) {
    state.menu = payload;
    state.activeName = activeName || '';
  },
  SETRELSKUTTYE: function SETRELSKUTTYE(state, payload) {
    state.relSkuType = payload;
  },
  SETCATA: function SETCATA(state, payload) {
    state.hostCatalogName = payload;
  },
  SET_IS_EXIST_STATEMENT_OF_ACCOUNT: function SET_IS_EXIST_STATEMENT_OF_ACCOUNT(state, payload) {
    state.isExistStatementOfAccount = payload;
  },
  // note 用来存储改变的分页的查询条件
  SAVE_LIST_PAGE_PARS: function SAVE_LIST_PAGE_PARS(state, _ref) {
    var path = _ref.path,
        pars = _ref.pars;
    state.listPagePars.set(path, pars);
  },
  // note 用来全量展示数据显示或者隐藏
  SAVE_Full_Scale_Display: function SAVE_Full_Scale_Display(state, _ref2) {
    var path = _ref2.path,
        pars = _ref2.pars;
    state.fullScaleDisplay.set(path, pars);
  },
  // note 机构管理用来存储id
  ORGIDREQITEM: function ORGIDREQITEM(state, itemId) {
    state.orgIdReqItem = itemId;
  },
  CHANGESUBMENU: function CHANGESUBMENU(state, payload) {
    if (payload.initialize && activeName) {
      // 初始化执行
      payload.data = level1(activeName).menuCode;
    } // 过滤左侧菜单


    state.subMenu = state.menu.filter(function (item) {
      return item.menuCode === payload.data;
    })[0].subMenus; // 激活展开菜单

    state.openName = state.subMenu[0].menuCode; // 是否外部系统菜单
    // state.extMenu = state.menu.filter(item => item.menuCode === payload.data)[0].extMenu;

    state.extMenu = level3(activeName).isVue;

    if (payload.initialize) {
      // 初始化执行
      if (activeName) {
        // 激活头部导航
        state.activeNav = payload.data; // 激活展开菜单

        state.openName = level2(activeName).menuCode;
      } else {
        state.openName = '';
      }
    } else {
      // 激活头部导航
      state.activeNav = payload.data; // 根据当前1级菜单判断二级菜单是否展开

      level1(state.activeName) === payload.data && (state.openName = level2(state.activeName).menuCode);
    }
  },
  CHANGEITEM: function CHANGEITEM(state, payload) {
    // 缓存点击菜单
    sessionStorage.setItem('activeName', payload.data); // 激活头部导航

    state.activeNav = level1(payload.data).menuCode; // 过滤左侧菜单

    state.subMenu = state.menu.filter(function (item) {
      return item.menuCode === state.activeNav;
    })[0].subMenus; // 激活展开菜单

    state.openName = level2(payload.data).menuCode; // 点击菜单赋值

    state.activeName = payload.data; // 是否外部系统菜单

    state.extMenu = payload.isVue; // 同步刷新左侧菜单高亮

    $IndexVue.$nextTick(function () {
      $IndexVue.$refs.sub.updateOpened();
      $IndexVue.$refs.sub.updateActiveName();
    });
  },
  RESET: function RESET(state, payload) {
    sessionStorage.removeItem('activeName');
    state.openName = '';
    state.activeNav = '';
    state.extMenu = false;
    state.activeName = '';
  },
  // 改变登录状态和用户信息
  CHANGELOGIN: function CHANGELOGIN(state, payload) {
    state.isLogin = payload.isLogin;
    state.userInfo = payload.userInfo;
    localStorage.setItem('userData', JSON.stringify(payload));
  },
  // 改变购物车数量
  CHANGECARTNUM: function CHANGECARTNUM(state, payload) {
    state.cartNum = payload.cartNum;
    localStorage.setItem('cartNum', payload.cartNum);
  },
  // 改变收藏数量
  CHANGECOLLECT: function CHANGECOLLECT(state, payload) {
    state.collectNum = payload.collectNum;
    localStorage.setItem('collectNum', payload.collectNum);
  },
  CHANGETRACEID: function CHANGETRACEID(state, payload) {
    state.traceId = payload.traceId;
    sessionStorage.setItem('traceId', payload.traceId);
  },
  // 改变未读消息
  CHANGENOREADCOUNT: function CHANGENOREADCOUNT(state, payload) {
    state.noReadCount = payload.noReadCount;
    sessionStorage.setItem('noReadCount', payload.noReadCount);
  },
  // 改变活动
  CHANGEACTIVITY: function CHANGEACTIVITY(state, payload) {
    state.selectedActivity = payload.selectedActivity;
    sessionStorage.setItem('selectedActivity', payload.selectedActivity);
  },
  // 改变业务
  CHANGEBUSINESS: function CHANGEBUSINESS(state, payload) {
    state.selectedBusiness = payload.selectedBusiness;
    sessionStorage.setItem('selectedBusiness', payload.selectedBusiness);
  },
  // 改变是否一物一码 true:是 false:否
  CHANGEISONETHINGYARD: function CHANGEISONETHINGYARD(state, payload) {
    state.isOneThingYard = payload.isOneThingYard;
    localStorage.setItem('isOneThingYard', payload.isOneThingYard);
  },
  // 改变运营侧左侧菜单状态 true：展开，false：折叠
  CHANGEISMENUEXPAND: function CHANGEISMENUEXPAND(state, payload) {
    state.isMenuExpand = payload;
    localStorage.setItem('isMenuExpand', payload);
  }
}; // actions

var actions = {
  initMenu: function initMenu(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;
    activeName = sessionStorage.getItem('activeName'); // Spin.show();

    var param = {
      appCode: CONSTANT.APP_CODE,
      time: new Date().getTime()
    };
    postApi(DYC_URL.umc_getUserMenus, param).then(function (res) {
      // Bus.$Spin.hide();
      if (res.menus && res.menus.length) {
        var menus = menuLibs(res.menus);
        commit(INITMENU, menus);
        commit(CHANGESUBMENU, {
          data: menus[0].menuCode,
          initialize: true
        });
        payload.$nextTick(function () {
          payload.$refs.sub.updateOpened();
          payload.$refs.sub.updateActiveName(); // payload.$refs.menu.updateActiveName();
        });
        sessionStorage.setItem('menuList', JSON.stringify(menus));
      } else {// Modal.error({
        //   title: '错误',
        //   content: '您尚未配置菜单，请联系管理员配置菜单！'
        // });
        // Bus.$HtBaseModal.error(
        //   {
        //     title: '错误',
        //     content: '您尚未配置菜单，请联系管理员配置菜单！',
        //     onOk: () => {
        //       dispatch('signOut',{ isLogin:false,userInfo: '' })
        //       //this.signOut({ isLogin:false,userInfo: '' });
        //       sessionStorage.removeItem('auth'); // 清除用户登录信息
        //       util.cookies.remove('auth-token');
        //       router.push({
        //         name: 'login'
        //       });
        //     }
        //   });
      }
    });
  },
  // note 用来调用存储改变分页的值
  saveListPagePars: function saveListPagePars(_ref4, _ref5) {
    var commit = _ref4.commit;
    var path = _ref5.path,
        pars = _ref5.pars;
    commit('SAVE_LIST_PAGE_PARS', {
      path: path,
      pars: pars
    });
  },
  // note 用来调用存储改变分页的值
  saveFullScaleDisplay: function saveFullScaleDisplay(_ref6, _ref7) {
    var commit = _ref6.commit;
    var path = _ref7.path,
        pars = _ref7.pars;
    commit('SAVE_Full_Scale_Display', {
      path: path,
      pars: pars
    });
  },
  // note 保存选中的机构Id
  saveOrgidReqItem: function saveOrgidReqItem(_ref8, itemId) {
    var commit = _ref8.commit;
    commit('ORGIDREQITEM', itemId);
  },
  changeSubMenu: function changeSubMenu(_ref9, payload) {
    var commit = _ref9.commit;
    commit(CHANGESUBMENU, {
      data: payload,
      initialize: false
    });
  },
  changeItem: function changeItem(_ref10, payload) {
    var commit = _ref10.commit;
    commit(CHANGEITEM, payload);
  },
  reset: function reset(_ref11) {
    var commit = _ref11.commit;
    commit(RESET);
  },
  // 获取购物车数量
  getCartNum: function getCartNum(_ref12, payload) {
    var getters = _ref12.getters,
        commit = _ref12.commit,
        state = _ref12.state;

    if (getters.getIsLogin) {
      var param = {
        spDesc: getters.getSelectedBusiness,
        spuId: getters.getSelectedActivity
      };
      postApi(DYC_URL.common_queryShoppingCartAmount, param).then(function (res) {
        var cartNum = 0;

        if (res) {
          _.forEach(res.uscSecondTabCountBOList, function (item) {
            cartNum += item.count;
          });

          if (getters.getUserInfo.tradeUserTypeSelectCook == 2) {
            commit('CHANGECARTNUM', {
              cartNum: 0
            });
            return {
              cartNum: 0
            };
          } else {
            commit('CHANGECARTNUM', {
              cartNum: cartNum
            });
            return {
              cartNum: cartNum
            };
          }
        }
      });
    }
  },
  // 获取收藏数量
  getCollectNum: function getCollectNum(_ref13, payload) {
    var dispatch = _ref13.dispatch,
        commit = _ref13.commit;

    if (!payload) {
      var params = {
        operType: 3,
        pageSize: 100,
        pageNo: 1
      };
      postApi(DYC_URL.common_goodsCollecAbility, params).then(function (res) {
        if (res) {
          commit('CHANGECOLLECT', {
            collectNum: res.recordsTotal
          });
        }
      });
    } else {
      commit('CHANGECOLLECT', payload);
    }
  },
  // 是否停用
  getIsUserBan: function getIsUserBan(_ref14, payload) {
    var dispatch = _ref14.dispatch,
        commit = _ref14.commit,
        state = _ref14.state;
    return new Promise(function (resolve, reject) {
      postApi(DYC_URL.umc_qryUserStatus, {
        userIdWeb: payload
      }).then(function (res) {
        if (res) {
          resolve(res);
        }
      }).catch(function (e) {
        reject(e);
      });
    });
  },
  // 切换登录
  swicthLogin: function swicthLogin(_ref15, payload) {
    var dispatch = _ref15.dispatch,
        commit = _ref15.commit,
        state = _ref15.state;
    return new Promise(function (resolve, reject) {
      postApi(DYC_URL.umc_loginBusiness, {
        newUserId: payload
      }).then(function (res) {
        if (res) {
          resolve(res);
        }
      }).catch(function (e) {
        reject(e);
      });
    });
  },
  // 登录
  login: function login(_ref16, payload) {
    var dispatch = _ref16.dispatch,
        commit = _ref16.commit,
        state = _ref16.state;
    return new Promise(function (resolve, reject) {
      postApi(DYC_URL.umc_getUserInfo, payload).then(function (res) {
        if (!res) {
          sessionStorage.removeItem('auth'); // 清除用户登录信息

          util.cookies.remove('auth-token');
          router.push({
            name: 'login'
          });
        } else {
          var obj = {};

          if (res.userId != null || res.userId != '') {
            obj = {
              isLogin: true,
              userInfo: {}
            };
            obj.userInfo = _.assign({}, res, {
              userName: res.username
            });
          } else {
            obj = {
              isLogin: false,
              userInfo: {}
            };
            commit('CHANGECARTNUM', {
              cartNum: ''
            });
          }

          commit(CHANGELOGIN, obj);
          resolve(obj.userInfo);
        }
      }).catch(function (e) {
        reject(e);
      });
    });
  },
  // 退出登录
  signOut: function signOut(_ref17, payload) {
    var state = _ref17.state,
        commit = _ref17.commit,
        dispatch = _ref17.dispatch,
        rootState = _ref17.rootState;
    postApi(DYC_URL.users_logout, {}).then( /*#__PURE__*/function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!res) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return dispatch('changeLoginOut', payload);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref18.apply(this, arguments);
      };
    }());
  },
  // 退出登录清除缓存信息
  changeLoginOut: function changeLoginOut(_ref19, payload) {
    var commit = _ref19.commit,
        dispatch = _ref19.dispatch;
    return new Promise( /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                util.cookies.remove('auth-token');
                util.cookies.remove('uuid');
                commit(CHANGELOGIN, payload);
                commit('CHANGECARTNUM', {
                  cartNum: ''
                });
                commit('CHANGECOLLECT', {
                  collectNum: ''
                });
                sessionStorage.removeItem('uOrgList');
                sessionStorage.removeItem('isChangeFlag');
                sessionStorage.removeItem('searchParam');
                sessionStorage.removeItem('menuList');
                sessionStorage.removeItem('noReadCount');
                commit('CHANGENOREADCOUNT', {
                  noReadCount: 0
                });
                commit('CHANGEACTIVITY', {
                  selectedActivity: ''
                });
                commit('CHANGEBUSINESS', {
                  selectedBusiness: ''
                });
                _context2.next = 15;
                return dispatch('admin/page.ht/closeAll', {}, {
                  root: true
                });

              case 15:
                commit('admin/menu.ht/INITMENU', [], {
                  root: true
                }); // end

                resolve();

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref20.apply(this, arguments);
      };
    }());
  },
  // 获取是否一物一码
  getIsOneThingYard: function getIsOneThingYard(_ref21, payload) {
    var getters = _ref21.getters,
        commit = _ref21.commit,
        state = _ref21.state;
    postApi(DYC_URL.commodity_noauthGetparametersDetail, {
      paramsId: '7'
    }).then(function (res) {
      if (res) {
        commit('CHANGEISONETHINGYARD', {
          isOneThingYard: res.rows[0].enable === 1
        });
      }
    });
  }
};

function level1(data) {
  queryCode(state.menu, 'menuCode', data);
  queryCode(state.menu, 'menuId', state.temp.parentId);
  queryCode(state.menu, 'menuId', state.temp.parentId);
  return state.temp;
}

function level2(data) {
  queryCode(state.menu, 'menuCode', data);
  queryCode(state.menu, 'menuId', state.temp.parentId);
  return state.temp;
}

function level3(data) {
  queryCode(state.menu, 'menuCode', data);
  return state.temp;
}

function queryCode(menu, code, active) {
  menu.forEach(function (item) {
    if (item[code] === active) {
      state.temp = item;
      return item;
    } else if (item.subMenus.length > 0) {
      queryCode(item.subMenus, code, active);
    }
  });
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};